import styled from 'styled-components';

export const SpeakerTestButtonWrapper = styled.div`
    margin-top: 8px;
`;

export const VolumeSliderWrapper = styled.div`
    margin-top: 10px;
`;
